import { PropEventBroker } from './PropEventBroker';
export var LoadingState;
(function (LoadingState) {
    LoadingState["IDLE"] = "IDLE";
    LoadingState["LOADING"] = "LOADING";
    LoadingState["ERROR"] = "ERROR";
    LoadingState["DONE"] = "DONE";
})(LoadingState || (LoadingState = {}));
export class LoadingStateBroker extends PropEventBroker {
    constructor(emitter, initialValue = LoadingState.IDLE) {
        super(emitter, initialValue);
    }
    setIdle() {
        this.set(LoadingState.IDLE);
    }
    setLoading() {
        this.set(LoadingState.LOADING);
    }
    setError() {
        this.set(LoadingState.ERROR);
    }
    setDone() {
        this.set(LoadingState.DONE);
    }
}
//# sourceMappingURL=LoadingStateBroker.js.map